export const CSRF_TOKEN = '__ibrakadabra';
export const SESSION = '__session';

const MINUTE = 60;
export const CACHE_CONTROL_HEADER = `public, max-age=${10 * MINUTE}, s-maxage=${10 * MINUTE}`;
export const VARY_HEADER = 'origin,cookie,need-authorization, x-fh-requested-host, accept-encoding, accept-language';

export const PROGRESS_CALCULATIONS_OMIT = ['kyc', 'taxDeclaration', 'bankDetails'];

export const URL_REGEXP =
  /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})|\/(localhost)/g;
